import { render, staticRenderFns } from "./CreateClustersModal.vue?vue&type=template&id=ba58de2c&"
import script from "./CreateClustersModal.vue?vue&type=script&lang=js&"
export * from "./CreateClustersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports